module.exports = __webpack_public_path__ + "img/lg_ring_y_l_0_0@3x.d66247c7.png";